export default __webpack_public_path__ + "static/media/mariekeseligmanKlein.438b2a31.jpg";